exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#erpSyncSettingModal .custom-control-input:checked ~ .custom-control-label::before,\n#erpSyncSettingModal .custom-control-input:checked ~ .custom-control-label::after {\n  background-color: #01b1af !important;\n  border-color: #01b1af !important;\n  border-radius: 100%;\n}\n", ""]);

// exports
